import * as React from 'react';
import {connect} from 'react-redux';

import {Field, formValueSelector, reset, change} from 'redux-form';

import {Label} from 'shells/form/label';
import {nonNull} from 'shells/form/validation/non-null';
import {ReduxFormSelectTwoLineIcon} from 'shells/redux-form-fields/select-two-line-icon/select-two-line-icon';

import * as Forms from '../../../core/form/fields';

import {nextStepTypeValues} from './constants';
import type {NextStepTypeEnum} from './constants';
import {FORM_NAME} from './drip-sequence-sidebar-form';

import styles from './forms.module.css';

const FORMS = {
    ADD_TAGS: Forms.AddTagForm,
    ADD_AUDIENCES: Forms.AudienceForm,
    REMOVE_AUDIENCES: Forms.AudienceForm,
} as const;

const nextStepSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        nextStepType: nextStepSelector(state, 'nextStepType'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onNextStepTypeChange: (newValue?: NextStepTypeEnum | null) => {
            dispatch(reset(FORM_NAME));
            dispatch(change(FORM_NAME, 'nextStepType', newValue));
        },
    };
}

type StateProps = {
    nextStepType?: NextStepTypeEnum;
};

type DispatchProps = {
    onNextStepTypeChange: (newValue?: NextStepTypeEnum | null | undefined) => void;
};

type Props = StateProps & DispatchProps;

export function AddNextStepFormComponent(props: Props) {
    const Component = props.nextStepType ? FORMS[props.nextStepType] : undefined;

    const {nextStepType, onNextStepTypeChange} = props;

    React.useEffect(() => {
        onNextStepTypeChange(nextStepType);
    }, [nextStepType, onNextStepTypeChange]);

    return (
        <div className={styles['wrapping-container']}>
            <div className={styles['form-description']}>
                Create a next step that will automatically take place if the goal of this drip
                sequence is met.
            </div>
            <Label htmlFor='nextStepType'>What happens after the goal is met?</Label>
            <Field
                name='nextStepType'
                component={ReduxFormSelectTwoLineIcon}
                options={nextStepTypeValues}
                validate={[nonNull]}
                placeholder='Select a next step'
            />
            {Component ? <Component shouldAnd={true} tagType='CONTACT' /> : undefined}
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const AddNextStepForm = connector(AddNextStepFormComponent);
